



























import NProgress from 'nprogress'
import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'

import LargeAvatar from '@/components/LargeAvatar.vue'
import UpdatePasswordForm from '@/components/UpdatePasswordForm.vue'

import ChangeDefaultPasswordForm from '@/models/change-default-password-form'
import Customer from '@/models/customer'
import ErrorEntities from '@/models/error-entities'

import store from '@/store'
import { CustomerActionTypes } from '@/store/modules/customer'
import { NewPasswordPageActionTypes } from '@/store/modules/newPasswordPage'

@Component({
  components: {
    UpdatePasswordForm,
    LargeAvatar,
  },
})
export default class NewPasswordPage extends Vue {
  defaultMessage = `Welcome to ${this.humanizedCompanyName}!`

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: Location) => void,
  ) {
    NProgress.start().set(0.6)

    await store.dispatch(NewPasswordPageActionTypes.GetWelcomePageMessage)
    await store.dispatch(NewPasswordPageActionTypes.GetPasswordResetMessage)

    NProgress.done()
    next()
  }

  get errors(): ErrorEntities {
    return this.$store.getters.getNewPasswordPageErrors
  }

  get customer(): Customer {
    return this.$store.getters.getCurrentCustomer
  }

  get welcomeMessage(): string {
    const welcomeMessage = this.$store.state.newPasswordPage.welcomeMessage

    return welcomeMessage.length ? welcomeMessage : this.defaultMessage
  }

  get passwordResetMessage(): string {
    const passwordResetMessage = this.$store.state.newPasswordPage
      .passwordResetMessage

    return passwordResetMessage.length
      ? passwordResetMessage
      : this.defaultMessage
  }

  onPasswordUpdate(form: ChangeDefaultPasswordForm) {
    this.$store.dispatch(CustomerActionTypes.ChangeDefaultPassword, form)
  }
}
